import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';

const firebaseConfigStaging = {
    apiKey: "AIzaSyBPDtZSVgWSmgwBngPUWDX7iiq3fiRjFBM",
    authDomain: "wbs-staging-89a35.firebaseapp.com",
    projectId: "wbs-staging-89a35",
    storageBucket: "wbs-staging-89a35.appspot.com",
    messagingSenderId: "278627746045",
    appId: "1:278627746045:web:d68d11ffb78fb0906a7e94",
    measurementId: "G-NQJ1WBSS4K"
};

const firebaseConfigProduction = {
    apiKey: "AIzaSyCBibu5GghhHpMZVDRtXT6CypsHvxMoY0I",
    authDomain: "elumen-mobile.firebaseapp.com",
    databaseURL: "https://elumen-mobile.firebaseio.com",
    projectId: "elumen-mobile",
    storageBucket: "elumen-mobile.appspot.com",
    messagingSenderId: "830588293735",
    appId: "1:830588293735:web:e10dc061e807b2cd80fac2",
    measurementId: "G-ZXRVBCKG9W"
};

const firebaseConfig = window.APP_ENV === 'Production' ? firebaseConfigProduction : firebaseConfigStaging;

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);

/**
 * Handles firebase auth errors and return a more user friendly error message
 * @param e firebase auth errors
 * @param defaultMessage default message if error code cannot be matched
 * @returns user friendly string
 */
export const translateFirebaseAuthError = (e, defaultMessage) => {
    switch (e.code) {
        // Email action links
        case 'auth/expired-action-code':
            return 'Your email link has expired. Please request another one and try again.';
        case 'auth/invalid-action-code':
            return 'Your email link is invalid. Please request another one and try again.';
        case 'auth/code-expired':
            return 'Code expired in provided link.';
        case 'auth/invalid-email':
            return 'Invalid email provided';

        // updateEmail
        case 'auth/invalid-new-email':
            return 'The email you have entered is invalid. Please check your spelling and try again.';
        case 'auth/email-already-in-use':
            return 'That email is already being used by another user. Please enter a different email and try again.';
        case 'auth/requires-recent-login':
            return 'Please log out and log in again first before trying again.';

        // Misc
        case 'auth/user-disabled':
            return 'Your account has been disabled. Please contact WBS support to continue.';
        case 'auth/user-not-found':
            return 'User does not exist for this email.';
        case 'auth/wrong-password':
            return 'Incorrect email and password combination.';
        case 'auth/missing-continue-uri':
            return 'Redirect is missing in link.';
        case 'auth/too-many-requests':
            return 'Too many attempts, please try again later or contact support.';
        case 'auth/account-exists-with-different-credential':
            return 'Email is already signed up using another provider, please log in';

        // updatePassword
        case 'auth/weak-password':
            return 'Password is too weak, please enter at least 8 characters.';

        // updatePhoneNumber
        case 'auth/invalid-verification-code':
            return 'Invalid verification code, please try again';
        case 'auth/invalid-verification-id':
            return 'Your phone code has expired. Please request another one and try again.';

        // PhoneAuthProvider.verifyPhoneNumber
        case 'auth/captcha-check-failed':
            return 'Captcha check failed. Please try again.';
        case 'auth/invalid-phone-number':
            return 'Your phone number is invalid. Please make sure it is in the correct format and try again.';
        case 'auth/missing-phone-number':
            return 'No phone number provided. Please enter a valid mobile number and try again.';
        case 'auth/quote-exceeded':
            return 'We\'re unable to send an SMS to you at this moment. Please contact WBS or try again later.';
        case 'auth/maximum-second-factor-count-exceeded':
            return 'You have already added the maximum number of second factors.';
        case 'auth/second-factor-already-in-use':
            return 'This phone number is already enrolled as a second factor on this account.';
        case 'auth/unsupported-first-factor':
            return 'Your primary sign in method is not supported. Please contact WBS for more information.';
        case 'auth/unverified-email':
            return 'Your account is not verified. Please verify your account first and try again.';
        default:
            return defaultMessage == null ? 'An unexpected error occurred, please try again later.' : defaultMessage;
    }
};